import { render, staticRenderFns } from "./Lgx243816597420835671.vue?vue&type=template&id=0042f1f2&scoped=true&"
import script from "./Lgx243816597420835671.vue?vue&type=script&lang=js&"
export * from "./Lgx243816597420835671.vue?vue&type=script&lang=js&"
import style0 from "./Lgx243816597420835671.vue?vue&type=style&index=0&id=0042f1f2&prod&scoped=true&lang=css&"
import style1 from "./Lgx243816597420835671.vue?vue&type=style&index=1&id=0042f1f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0042f1f2",
  null
  
)

export default component.exports